// Batch upload helpers for grouping small files into multipart requests.
import {
  BATCH_UPLOAD_MAX_FILES,
  BATCH_UPLOAD_MAX_SINGLE_FILE_SIZE,
  BATCH_UPLOAD_MAX_TOTAL_SIZE
} from "@/js/upload/config";

const splitFilesForBatch = files => {
  const smallFiles = [];
  const largeFiles = [];
  for (const file of files) {
    if (!file) {
      continue;
    }
    if (
      file.size > BATCH_UPLOAD_MAX_SINGLE_FILE_SIZE ||
      file.size > BATCH_UPLOAD_MAX_TOTAL_SIZE
    ) {
      largeFiles.push(file);
    } else {
      smallFiles.push(file);
    }
  }
  return { smallFiles, largeFiles };
};

const splitFilesIntoBatches = files => {
  const batches = [];
  let current = [];
  let currentBytes = 0;

  for (const file of files) {
    const nextBytes = currentBytes + (file?.size || 0);
    if (
      current.length >= BATCH_UPLOAD_MAX_FILES ||
      nextBytes > BATCH_UPLOAD_MAX_TOTAL_SIZE
    ) {
      if (current.length) {
        batches.push(current);
      }
      current = [];
      currentBytes = 0;
    }
    current.push(file);
    currentBytes += file?.size || 0;
  }

  if (current.length) {
    batches.push(current);
  }

  return batches;
};

export { splitFilesForBatch, splitFilesIntoBatches };
